<div class="drilldown-chart-container">
  <ng-container *ngIf="!isLoading; else skeletonLoader">
    <div class="drilldown-chart-container-header" [ngClass]="size">
      <div>{{ title }}</div>
      <div>
        <ng-container *ngIf="showInfoTooltip">
          <mat-icon
            svgIcon="info"
            class="drilldown-chart-container-button"
            cdkOverlayOrigin
            #infoOrigin="cdkOverlayOrigin"
            (mouseenter)="infoTooltipOpen = true"
            (mouseleave)="infoTooltipOpen = false"
          ></mat-icon>
          <cds-tooltip
            [origin]="infoOrigin"
            [open]="infoTooltipOpen"
            placement="left"
            [panelWidth]="256"
            [hasBackdrop]="false"
            (hovered)="infoTooltipOpen = true"
            (unhovered)="infoTooltipOpen = false"
          >
            <ng-template #tooltipContent>
              {{ infoText || 'No information available' }}
            </ng-template>
          </cds-tooltip>
        </ng-container>
        <mat-icon
          *ngIf="size === 'medium' && showEnlargeButton"
          svgIcon="enlarge"
          class="drilldown-chart-container-button"
          (click)="onExpandChartClicked()"
        ></mat-icon>
      </div>
    </div>
    <ng-content select="[chart-element]"></ng-content>
  </ng-container>

  <ng-template #skeletonLoader>
    <div class="drilldown-chart-container-skeleton" [ngClass]="size">
      <ngx-skeleton-loader
        count="1"
        appearance="line"
        [theme]="{
          width: '100%',
          height: getSkeletonHeaderHeight()
        }"
      />
      <ngx-skeleton-loader
        count="1"
        appearance="line"
        class="drilldown-chart-container-skeleton-body"
        [theme]="{
          width: '100%',
          height: getSkeletonBodyHeight(),
          borderRadius: '5px'
        }"
      >
      </ngx-skeleton-loader>
    </div>
  </ng-template>
</div>
